<template>
  <van-popup v-model="showRules" class="rule-popup" closeable>
    <div class="wrapper" @click.stop>
      <div class="rule detail">
        <div class="text">
          <img src="@/static/images/activityCenter/icon-left.png" alt="" />
          <span>规则详情</span>
          <img src="@/static/images/activityCenter/icon-right.png" alt="" />
        </div>
        <div class="contentInfo">
          <p v-html="rule" style="padding-left: 0"></p>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      showRules: false,
      rule: '<div><h2>一、活动时间</h2><p>2024年3月1日-2024年3月31日</p><p><br/></p><h2>二、活动对象：</h3><p>OK保已签约代理人</p><p><br/></p><h3>三、活动参与：</h3><p>1、出单活动清单范围内的产品，且累计业绩达到标准。</p><p>2、业绩计算按照标准保费计算规则:</p><p>趸交:标准保费&nbsp;=&nbsp;保单保费&nbsp;X&nbsp;0.1</p><p>交费期限3年期:标准保费&nbsp;=&nbsp;保单保费&nbsp;X&nbsp;0.3</p><p>交费期限5年期:标准保费&nbsp;=&nbsp;保单保费&nbsp;X&nbsp;0.5</p><p>交费期限10年期及以上:&nbsp;标准保费&nbsp;=&nbsp;保单保费&nbsp;X&nbsp;1</p><p><br/></p><h3>四、利多多3号&nbsp;&nbsp;&nbsp;限时出单瓜分奖金</h3><h4>（一）活动内容</h4><p>累计标保业绩满1万元&nbsp;&nbsp;&nbsp;&nbsp;奖388元</p><p>累计标保业绩满5万元&nbsp;&nbsp;&nbsp;&nbsp;奖1288元</p><p>累计标保业绩满10万元&nbsp;&nbsp;&nbsp;奖2888元</p><p><br/></p><h3>五、大单奖励</h3><h4>（一）活动内容</h4><p>累计标保业绩满1万元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;奖188元</p><p>累计标保业绩满8万元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;奖666元</p><p>累计标保业绩满15万元&nbsp;&nbsp;&nbsp;&nbsp;奖1888元</p><p><br/></p><h4>（二）活动产品</h4><p><img src=\"\"/><img src=\"https://file-test.lazhuyun.cn/upload/image/2024/02/29/1709199517160861084.png\" contenteditable=\"false\" style=\"font-size: 13px; max-width: 100%;\"/></p><br/><h4></h4><h4></h4><h3>六、活动规则</h3><p>1、活动期间内，出单对应类别活动清单内的产品，累计业绩达标，可获得对应的现金奖励</p><p>2、对应类别的累计业绩奖励仅以达成的最高门槛对应的奖励进行发放，不可重复获得。</p><p>3、投保时间和承保时间都需要在活动期间内，在活动结束次月20日24点前成功通过质检、且签收回执、保单过犹过访，满足以上所有条件方可计入活动业绩。</p><p>4、活动订单仅计算活动期间所出新单，不含追加、加保、续期订单。</p><p><br/></p><h3>七、注意事项</h3><p>1、如遇退保，OK保将扣回此单所有推广费及所有奖励。</p><p>2、如发现同一代理人活动期间退保率超过10%，OK保有权追回所有奖励。</p><p>3、代理人奖励发放时，需满足平台业务品质要求。如不满足，平台有权不予发放奖励。OK保有权对业绩品质进行质检。</p><p>4、参加活动要求个人继续率&nbsp;≥90%，且个人新单退保率&lt;5%，达标与否，将以活动开始前定版数据&nbsp;(即2024.2.29日零点系统数据)&nbsp;为准。</p><p>5、严禁恶意拆单，若发现多笔订单均为同一被保人、投保人、出单人、同一产品，则视为同一个订单，仅发放一次奖励。</p><p>6、代理人若在奖励发放前离职，则奖励不予结算。</p><p><br/></p><h3>八、活动奖励发放</h3><p>1、现金奖励将会在活动结束后的次月20日之后进行发放。未回执回访，未完成质检单录，或产生退保的订单奖励不予结算。</p><p>2、退保的情况下，业绩数据同步会有延迟，以活动结束后的最终核算业绩（扣除退保件等）为主，来进行奖励发放。</p><p><br/></p><p>以上奖励条件以系统记录为准，若出现刷单或恶意投诉，OK保将保留追究法律责任的权利。本活动最终解释权归梧桐树保险经纪有限公司所有。<br/></p></div><div></div><div><div></div></div>'
    };
  },

  methods: {
    open() {
      this.showRules = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  background: transparent !important;
}

/deep/.rule-popup {
  background-color: transparent;
  /deep/.van-popup__close-icon {
    top: 52px;
  }
}
.wrapper {
  width: 690px;
}
.rule {
  padding: 0 30px 10px;
  .contentInfo {
    max-height: 80vh;
    overflow-y: scroll;
  }
  p {
    font-size: 26px;
    color: #643d2e;
    padding-left: 42px;
    margin-top: 10px;
    margin-bottom: 30px;
  }
  /deep/table {
    border-collapse: collapse;
    td {
      border: 1px solid #643d2e;
    }
  }
}
.detail {
  background: #ffffff;
  border-radius: 16px;
  border: 0.053rem solid rgb(255, 225, 124);
  margin-top: 30px;
  padding: 0 25px;
  position: relative;
  z-index: 1;
  .text {
    width: 252px;
    height: 73px;
    background: linear-gradient(300deg, #fd9336 0%, #f97936 43%, #f45b37 100%);
    border-radius: 0px 0px 32px 32px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 34px;
    font-weight: 500;
    color: #ffffff;
    margin-top: -0.053rem;
    img {
      width: 30px;
      height: 25px;
    }
    span {
      margin: 0 10px;
    }
  }
}
/deep/table p {
  width: 200px;
  text-align: center;
}
</style>
